import { Injectable } from '@angular/core';
import { ActionErrorAlert, CustomAlert, TextAlert, TryAgainActionErrorAlert, UndoAlert } from '../../models';
import { AlertStoreService } from '../alert-store/alert-store.service';
import { v4 } from 'uuid';
import { ActionSuccessAlert, LoadingAlert } from '../../models/alert';

@Injectable()
export class AlertService {
  constructor(private alertStore: AlertStoreService) {}

  openActionErrorAlert(actionErrorAlert: ActionErrorAlert): void {
    this.alertStore.addAlert(actionErrorAlert, 'actionError');
  }

  openTryAgainActionError(tryAgainActionErrorAlert: TryAgainActionErrorAlert): void {
    tryAgainActionErrorAlert.id = tryAgainActionErrorAlert.id || v4();

    this.alertStore.addAlert(tryAgainActionErrorAlert, 'tryAgainActionError');

    if (tryAgainActionErrorAlert.disappearTimeout) {
      this.alertStore.removeAlertByTimeoutAction(tryAgainActionErrorAlert.id, tryAgainActionErrorAlert.disappearTimeout);
    }
  }

  openCustomAlert(customAlert: CustomAlert): void {
    customAlert.id = customAlert.id || v4();
    this.alertStore.addAlert(customAlert, 'custom');

    if (customAlert.disappearTimeout) {
      this.alertStore.removeAlertByTimeoutAction(customAlert.id, customAlert.disappearTimeout);
    }
  }

  openUndoAlert(undoAlert: UndoAlert): void {
    undoAlert.id = undoAlert.id || v4();
    this.alertStore.addAlert(undoAlert, 'undo');

    if (undoAlert.disappearTimeout) {
      this.alertStore.removeAlertByTimeoutAction(undoAlert.id, undoAlert.disappearTimeout);
    }
  }

  openLoadingAlert(loadingAlert: LoadingAlert): void {
    loadingAlert.id = loadingAlert.id || v4();
    this.alertStore.addAlert(loadingAlert, 'loading');

    if (loadingAlert.disappearTimeout) {
      this.alertStore.removeAlertByTimeoutAction(loadingAlert.id, loadingAlert.disappearTimeout);
    }
  }

  openActionSuccessAlert(actionSuccessAlert: ActionSuccessAlert): void {
    actionSuccessAlert.id = actionSuccessAlert.id || v4();
    this.alertStore.addAlert(actionSuccessAlert, 'actionSuccess');

    if (actionSuccessAlert.disappearTimeout) {
      this.alertStore.removeAlertByTimeoutAction(actionSuccessAlert.id, actionSuccessAlert.disappearTimeout);
    }
  }

  openAlert(textAlert: TextAlert): void {
    textAlert.id = textAlert.id || v4();
    this.alertStore.addAlert(textAlert, 'text');

    if (textAlert.disappearTimeout) {
      this.alertStore.removeAlertByTimeoutAction(textAlert.id, textAlert.disappearTimeout);
    }
  }

  removeAlert(alertId: string): void {
    this.alertStore.removeAlertAction(alertId);
  }

  removeAllAlerts(): void {
    this.alertStore.removeAll();
  }
}
